import React, { useEffect } from "react";
import DataTable from "./DataTable";
import moment from "moment";
import { Icons } from "../constants/icon-library";
import { useNavigate } from "react-router-dom";
import { confirmAndDelete } from "./constants";
import { useDispatch, useSelector } from "react-redux";
import { deleteMeeting, getAllMeetings } from "../features/admin/adminSlice";

function Meetings() {
  const { meetings = [] } = useSelector((state) => state.admin);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllMeetings());
  }, [dispatch]);

  const handleRemove = (uuid) => {
    confirmAndDelete({
      uuid,
      dispatch,
      deleteThunk: deleteMeeting,
      successMessage: "Meeting removed successfully.",
      errorMessage: "Failed to remove meeting.",
    });
  };
  const columns = [
    { label: "Title", key: "title" },
    { label: "Agent", key: "agent.name" },
    { label: "Status", key: "status" },
    { label: "Participants", key: "participants" },
    { label: "Tasks", key: "tasks" },
    { label: "Account Email", key: "user.email" },
    { label: "Date", key: "date" },
    { label: "Action", key: "action" },
  ];

  const rowRenderer = (m) => (
    <tr key={m.uuid}>
      <td className="align-middle ps-3">{m.title}</td>

      <td className="align-middle ps-3">{m?.agent?.name || "-"}</td>

      <td className="align-middle ps-3">{m?.status}</td>

      <td className="align-middle ps-3">{m?.participants?.length || 0}</td>
      <td className="align-middle ps-3">{m?.tasks?.total || 0}</td>
      <td className="align-middle ps-3">{m?.user?.email || "-"}</td>

      <td className="align-middle ps-3">
        {moment.utc(m?.date).format("MMM D, YYYY • h:mm A")}
      </td>

      <td className="align-middle text-end">
        <div className="btn-reveal-trigger position-static">
          <button
            className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
            type="button"
            data-bs-toggle="dropdown"
            data-boundary="window"
            aria-expanded="false"
            data-bs-reference="parent"
          >
            <i className={`wb ${Icons("dots")} fs-8 me-2 mt-3 align-middle`} />
          </button>

          <div className="dropdown-menu dropdown-menu-end py-2">
            <button
              className="dropdown-item"
              onClick={() => navigate(`/admin/meetings/${m.uuid}`)}
            >
              View Meeting
            </button>

            <div className="dropdown-divider"></div>

            <button
              className="dropdown-item text-danger"
              onClick={() => handleRemove(m.uuid)}
            >
              Delete
            </button>
          </div>
        </div>
      </td>
    </tr>
  );

  return (
    <div className="content">
      <div className="row">
        <div className="col-12">
          <DataTable
            title="Meetings"
            data={meetings}
            columns={columns}
            rowRenderer={rowRenderer}
          />
        </div>
      </div>
    </div>
  );
}

export default Meetings;
